/**
 * AuthoringGuide — Blueprints "Authoring guide" tab content.
 *
 * Embeds `docs/blueprints/authoring-guide.md` via the shared `<EmbeddedDoc>`
 * primitive (see ../techdocs/EmbeddedDoc.tsx). Edits to the guide go through
 * a normal markdown PR — mkdocs auto-discovers the file and TechDocs
 * rebuilds on the next deploy. The same content is reachable directly at
 * /docs/default/component/backstage/blueprints/authoring-guide for users
 * who arrive via the Docs sidebar.
 */

import EmbeddedDoc from '../techdocs/EmbeddedDoc';

export default function AuthoringGuide(): JSX.Element {
  return <EmbeddedDoc path="blueprints/authoring-guide" />;
}
